import React, { memo } from "react";
import { TableRow } from "@mui/material";
import { StyledTableCell } from "../../../../../shared/components/CustomTable/Styled";
import TextBox from "../../../../../shared/components/TextBox";
import DeleteIcon from "../../../../../shared/svg/DeleteIcon";
import IconButton from "../../../../../shared/components/IconButton";
import CustomTable from "../../../../../shared/components/CustomTable";
import SearchBarWithSuggestion from "../../../../../shared/components/SearchBar/SearchBarWithSuggestion";
import { api } from "../../../../../shared/hooks/api";
import { formatInternationalNumber, parseInternationalToNumber } from "../../../../../utils/format";
import { error } from "../../../../../utils/toast";
import { buildInventoryModalSearchParams } from "../../../../../utils/inventoryModalSearchParams";

interface ExportProductListProps {
    selectedProducts: any[];
    setSelectedProducts: (data: any) => void;
    exportInfo: any;
    disableQuantityInput?: boolean;
}

interface ProductRowProps {
    item: any;
    extraRowProps: any;
}

export const TableColumns = [
    { text: "Sản phẩm", icon: null },
    { text: "Số lượng xuất", icon: null },
    { text: "Ghi chú", icon: null },
    { text: "", icon: null },
];

const ProductRow = memo(({ item, extraRowProps }: ProductRowProps) => {
    return (
        <TableRow>
            <StyledTableCell>{item.name}</StyledTableCell>
            <StyledTableCell>
                <TextBox
                    numeric
                    style={{ width: "80px" }}
                    text={formatInternationalNumber(item.exportQuantity ?? "")}
                    onChangeText={(value: string) => {
                        const n = parseInternationalToNumber(value, error);
                        if (!Number.isFinite(n)) return;
                        extraRowProps.onChangeExportQuantity(item.id, n);
                    }}
                    disabled={!!extraRowProps?.disableExportQuantity}
                />
            </StyledTableCell>
            <StyledTableCell>
                <TextBox
                    text={item.note || ""}
                    onChangeText={(value: string) => extraRowProps.onChangeNote(item.id, value)}
                    style={{ width: "150px" }}
                />
            </StyledTableCell>
            <StyledTableCell>
                <IconButton onClick={() => extraRowProps.removeSelectedItem(item.id)}>
                    <DeleteIcon />
                </IconButton>
            </StyledTableCell>
        </TableRow>
    );
});

ProductRow.displayName = "ProductRow";

export const ExportProductList = ({
                                      selectedProducts,
                                      setSelectedProducts,
                                      disableQuantityInput,
                                  }: ExportProductListProps) => {
    const [{ data }, fetchProducts] = api.get(
        "/products/",
        buildInventoryModalSearchParams(),
        true,
    );

    const products = data && (data as any).results ? (data as any).results : [];

    const fetchItems = (variables: any) => {
        fetchProducts(buildInventoryModalSearchParams(variables), true);
    };


    const handleOnclickItem = (item: any, checked: boolean) => {
        if (checked) {
            if (!selectedProducts.find((product) => product.id === item.id)) {
                setSelectedProducts([...selectedProducts, { ...item, exportQuantity: 0, note: "" }]);
            }
        } else {
            setSelectedProducts(selectedProducts.filter((product) => product.id !== item.id));
        }
    };

    const onChangeExportQuantity = (id: string, quantity: number) => {
        const updatedProducts = selectedProducts.map((product: any) =>
            product.id === id ? { ...product, exportQuantity: quantity } : product,
        );
        setSelectedProducts(updatedProducts);
    };

    const onChangeNote = (id: string, note: string) => {
        const updatedProducts = selectedProducts.map((product: any) =>
            product.id === id ? { ...product, note } : product,
        );
        setSelectedProducts(updatedProducts);
    };

    const removeSelectedItem = (id: string) => {
        const filteredProducts = selectedProducts.filter((selectedItem: any) => selectedItem.id !== id);
        setSelectedProducts(filteredProducts);
    };

    return (
        <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 20 }}>
            <SearchBarWithSuggestion
                menuList={products}
                selectedItems={selectedProducts}
                placeholder="Tìm kiếm sản phẩm"
                fetchItems={fetchItems}
                handleOnclickItem={handleOnclickItem}
            />
            <CustomTable
                itemList={selectedProducts}
                TableColumns={TableColumns}
                RowElement={ProductRow}
                extraRowProps={{
                    onChangeExportQuantity,
                    onChangeNote,
                    removeSelectedItem,
                    disableExportQuantity: !!disableQuantityInput,
                }}
            />
        </div>
    );
};
